import React, { useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/router';
import { signIn, useSession } from 'next-auth/react';
import Login, { LoginProps } from 'components/commercetools-ui/organisms/authentication/login';
import Tile from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/authentication/tile';
import { Overlay, isSSOEnabled } from '@loomstateorg/shared-frontend';
import Redirect from 'helpers/redirect';
import { useAccount } from 'frontastic/hooks';
import { Reference } from 'types/reference';

export interface Props {
  data: any;
}

const AccountLoginTastic: React.FC<Props> = ({ data }) => {
  const { backgroundImage, backgroundImageWidth, shortText, icon, title, logo, backgroundColor } =
    data?.data?.dataSource?.fields ?? {};
  const [imageWidth, setImageWidth] = useState(0);
  const router = useRouter();
  const { status: sessionStatus, data: session } = useSession();
  const { loggedIn } = useAccount();
  const ssoEnabled = isSSOEnabled();

  const accountDataLinks: LoginProps = useMemo(
    () => ({
      accountLink: '/' as unknown as Reference,
      signInLink: '/login' as unknown as Reference,
      logo: logo?.fields?.file?.url?.toString(),
      src: logo?.fields?.file?.url?.toString(),
    }),
    [logo]
  );

  const redirectLink = useMemo(() => {
    const lastVisitedPage = router.query.lvp ? `/${router.query.lvp}` : accountDataLinks.accountLink;
    return lastVisitedPage;
  }, [accountDataLinks.accountLink, router]);

  useEffect(() => {
    if (backgroundImageWidth) {
      setImageWidth(Number(backgroundImageWidth) - 100);
    }
  }, [backgroundImageWidth]);

  useEffect(() => {
    if (!ssoEnabled) return;
    if (sessionStatus === 'loading' || session) return;
    void signIn('keycloak', { callbackUrl: '/' });
  }, [ssoEnabled, sessionStatus, session]);

  if (loggedIn) return <Redirect target={redirectLink} />;

  if (ssoEnabled) {
    return <Overlay />;
  }

  return (
    <div className={`relative flex h-screen items-center justify-center bg-center`}>
      <div
        className="absolute inset-0"
        style={{
          zIndex: -1,
          backgroundColor: `#${backgroundColor}`,
        }}
      />
      <img
        src={backgroundImage?.fields?.file?.url?.toString()}
        alt="Background"
        className="absolute left-0 top-0 h-full w-full object-cover"
        color="#FBF1E5"
        style={{
          zIndex: -1,
          transform: `translateX(${imageWidth}%)`,
        }}
      />
      <div className="grid grid-cols-1 items-center gap-48 md:grid-cols-3 md:gap-32" style={{ zIndex: 1 }}>
        <div className=""></div>
        <div className="rounded-lg bg-white px-16 py-28 lg:p-[48px]">
          <Login {...accountDataLinks} />
        </div>
        <div className="hidden max-w-[320px] md:block">
          <Tile icon={icon?.fields?.file?.url?.toString()} text={shortText} title={title} />
        </div>
      </div>
    </div>
  );
};

export default AccountLoginTastic;
